import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { buildAppUrl } from "../utils/appLinks";

/**
 * Destinos no app para os CTAs da landing.
 * A landing não conhece Auth0 nem Stripe: só aponta para o app.
 */
export const useAppLinks = () => {
  const { search } = useLocation();

  return useMemo(
    () => ({
      login: buildAppUrl(),
      signup: buildAppUrl("/cadastro", { search }),
      subscribe: (planoChave) =>
        buildAppUrl("/assinar", { params: { plano: planoChave }, search }),
    }),
    [search]
  );
};
